<template>
  <div class="footer-box">
    <div class="footer">
      <!-- 左边 -->
      <div class="footer-left">
        <div class="title-wrap">
          <!--          <img class="logo c-min-img" :src="require('@/assets/home/logo.png')" alt="">-->
          <div class="company">{{ $t('footer.title') }}</div>
        </div>
        <div class="address">{{ $t('footer.address') }}</div>
        <div class="approach">
          <div v-for="(item, index) in approachList" :key="index" @mouseenter.stop="toApproach(item, index)"
            class="item_icon">
            <img :src="approachId == index ? item.lightImg : item.img" alt="">
          </div>
        </div>
        <div class="qr-code">
          <a href="https://www.rzzxxc.com/zxapi/sys/common/preview/online/17884067650664028b207a045f64101a06559960a0007.jpg_fileName=576612476a35eeec4d189f01e7b35519.jpg"
            target="_blank"> <img :src="require('@/assets/aboutUs/576612476a35eeec4d189f01e7b35519.jpg')" alt=""></a>

        </div>
      </div>

      <!-- 右边 -->
      <div class="footer-right">
        <div>
          <div class="productBox">{{ $t('footer.menus.item1.title') }}</div>
          <div class="productItem" v-for="(item, index) in productList" :key="index" @click="productPath(item)">
            {{ $t(`footer.menus.item1.menus.${index}`) }}
          </div>
        </div>
        <!-- <div>
          <div class="productBox">解决方案</div>
          <div class="productItem" v-for="(item, index) in resolveList" :key="index" @click="resolvePath(item)">
            {{ item.name }}
          </div>
        </div> -->
        <!-- <div>
          <div class="productBox">企业资讯</div>
          <div class="productItem" v-for="(item, index) in companyList" :key="index" @click="companyPath(item)">
            {{ item.name }}
          </div>
        </div> -->
        <div>
          <div class="productBox">{{ $t('footer.menus.item2.title') }}</div>
          <div class="productItem" v-for="(item, index) in cooperateList" :key="index" @click="cooperatePath(item)">
            {{ $t(`footer.menus.item2.menus.${index}`) }}
          </div>
        </div>
        <div>
          <div class="productBox">{{ $t('footer.menus.item3.title') }}</div>
          <div class="productItem" v-for="(item, index) in aboutList" :key="index" @click="usAboutPath(item)">
            {{ $t(`footer.menus.item3.menus.${index}`) }}
          </div>
        </div>
      </div>
    </div>
    <a-divider />
    <!--    <div class="record">© 2020 中鑫新材料（日照）有限公司, 鲁ICP备. 18032918号-2</div>-->
  </div>
</template>

<script>
export default {
  data() {
    return {
      // cruuent:0,
      approachId: 0,
      // 途径
      approachList: [{
        img: require('@/assets/home/weixin 1.png'),
        lightImg: require('@/assets/home/weixin2.png'),
      },
        // {
        //   img: require('@/assets/home/douyin1.png'),
        //   lightImg: require('@/assets/home/douyin2.png'),
        // },
        // {
        //   img: require('@/assets/home/lianxifangshi1.png'),
        //   lightImg: require('@/assets/home/lianxifangshi2.png'),
        // }
      ],
      gzhList: [
        'http://58.59.63.5:19000/storeyardfile/temp/1_1713237561040.png',
        'http://58.59.63.5:19000/storeyardfile/temp/22_1687225152295.jpg'
      ],
      productList: [
        //   {
        //   name: "智慧河湖",
        //   path: '/lake'
        // },
        // {
        //   name: "智慧消防",
        //   path: '/fireProtection'
        // },
        // {
        //   name: "智慧农业",
        //   path: '/agriculture'
        // },
        // {
        //   name: "智慧社区",
        //   path: '/community'
        // },
        // {
        //   name: "智慧养老",
        //   path: '/retirement'
        // },
        // {
        //   name: "企业名片",
        //   path: '/businessCard'
        // },
        // {
        //   name: "放心消费一码通",
        //   path: '/storeYard'
        // },
        // {
        //   name: "分销商城",
        //   path: '/distributionMall'
        // },
        // {
        //   name: "工业经济监测平台",
        //   path: '/industrialEconomy'
        // },
        // {
        //   name: "App小程序定制开发",
        //   path: '/customization'
        // },
        // {
        //   name: "系统定制",
        //   path: '/systemCustomization'
        // },
        {
          name: "石塑箱",
          path: '/weedingRobot'
        },
        {
          name: "石塑建材",
          path: '/transportRobot'
        },
        // {
        //   name: "太阳能阀门控制器",
        //   path: '/irrigationSystem'
        // },
      ],

      resolveList: [{
        name: '智慧消防解决方案',
        path: '/solutionFireProtection',
      },
      {
        name: '智慧社区解决方案',
        path: '/solutionCommunity',
      },
      {
        name: '智慧养老解决方案',
        path: '/solutionRetirement',
      },
      {
        name: '农业灌溉解决方案',
        path: '/irrigationSystem',
      },
        // {
        //   name: '企业网站99元建站',
        //   path: '/companyWeb',
        // },
      ],

      companyList: [
        {
          name: '企业资讯',
          path: '/companyConsult'
        }
      ],

      cooperateList: [{
        name: '企业生态理念',
        path: '/cooperation'
      },
      {
        name: '合作伙伴招募',
        path: "/cooperation"
      },
      ],

      aboutList: [{
        name: '公司简介',
        path: '/aboutUs'
      },
      {
        name: '荣誉资质',
        path: '/aboutUs'
      },
      {
        name: '企业文化',
        path: '/aboutUs'
      },
      {
        name: '联系我们',
        path: '/aboutUs'
      },
      ]
    }
  },

  methods: {
    // 产品中心跳转
    productPath(item) {
      this.$router.push({
        path: item.path
      }, () => {
      })
    },

    // 解决方案跳转
    resolvePath(item) {
      this.$router.push({
        path: item.path
      }, () => {
      })
    },

    // 企业资讯跳转
    companyPath(item) {
      this.$router.push({
        path: item.path
      }, () => {
      })
    },

    // 合作共赢跳转
    cooperatePath(item) {
      this.$router.push({
        path: item.path
      }, () => {
      })
    },

    // 关于我们跳转
    usAboutPath(item) {
      this.$router.push({
        path: item.path
      }, () => {
      })
    },

    // 途径
    toApproach(item, index) {
      console.log(index, 23123131)
      if (this.approachId == index) return
      this.approachId = index
    }
  }
}
</script>

<style scoped lang="less">
.footer-box {
  width: 100%;
  background: #121127;
  padding-bottom: 20px;

  .footer {
    width: 100%;
    display: flex;
    justify-content: space-evenly;

    .footer-left {
      flex: 0 0 auto;
      width: 620px;
      padding: 60px 170px 20px 0px;

      .title-wrap {
        padding: 5px 0;

        display: flex;
        align-items: center;
        gap: 10px;
      }

      .logo {
        width: 30px;
        height: 30px;
      }

      .company {
        font-style: normal;
        font-weight: 400;
        font-size: 21px;
        line-height: 1;
        color: #fff;
      }

      .address {
        font-style: normal;
        font-weight: 400;
        font-size: 21px;
        color: #fff;
        padding-top: 10px;
      }

      .approach {
        width: 130px;
        display: flex;
        align-items: center;
        // justify-content: ;
        margin-top: 25px;
        cursor: pointer;

        .item_icon {
          margin-right: 10px;
        }

        img {
          width: 26px;
          height: 26px;
        }
      }

      .qr-code {
        margin-top: 25px;
        width: 133px;
        height: 153px;
        border-radius: 5px;

        img {
          width: 100%;
          height: 100%;
          border-radius: 5px;
        }
      }
    }

    .footer-right {
      // width: 850px;
      min-width: 50%;
      padding-top: 60px;
      display: flex;
      justify-content: space-between;

      .productBox {
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        color: rgba(255, 255, 255, 0.4);
        margin-bottom: 25px;
      }

      .productItem {
        font-style: normal;
        font-weight: 400;
        font-size: 21px;
        color: #fff;
        padding-bottom: 15px;
        cursor: pointer;
      }
    }
  }

  .ant-divider-horizontal {
    min-width: 81%;
    margin: 24 auto;
    background: rgba(255, 255, 255, 0.12);
  }

  .record {
    font-weight: 400;
    font-size: 21px;
    text-align: center;
    color: rgba(255, 255, 255, 0.56);
  }
}
</style>
